import { render, staticRenderFns } from "./leader-page-bottom-inHeader.vue?vue&type=template&id=4faa8d0e&"
import script from "./leader-page-bottom-inHeader.vue?vue&type=script&lang=js&"
export * from "./leader-page-bottom-inHeader.vue?vue&type=script&lang=js&"
import style0 from "./leader-page-bottom-inHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports